import Link from "next/link"
import { MdOutlineSearchOff } from "react-icons/md"

export default function NotFound() {
  return (
    <main className='mx-auto flex min-h-screen w-full max-w-400 flex-col items-center justify-center gap-12 px-7 text-gray-900'>
      <div className='flex justify-center'>
        <div className='flex h-28 w-28 items-center justify-center rounded-full bg-linear-to-br from-gray-50 to-gray-100'>
          <MdOutlineSearchOff className='size-14 text-gray-400' />
        </div>
      </div>

      <div className='flex flex-col gap-3 text-center'>
        <h1 className='font-bold text-[clamp(1.75rem,4vw,2.5rem)] leading-tight'>
          Loja nao encontrada
        </h1>
        <p className='text-gray-600 text-sm leading-relaxed'>
          Desculpe, a loja que voce esta procurando nao existe, foi removida ou
          o link pode estar incorreto. Tente novamente com um link diferente ou
          explore outras lojas.
        </p>
      </div>

      <div className='flex flex-col gap-2 sm:flex-row sm:justify-center sm:gap-3'>
        <Link
          className='flex items-center justify-center gap-2 rounded-lg bg-primary px-6 py-3 font-semibold text-white transition-all hover:bg-primary/80 active:scale-95'
          href='/'
        >
          Explorar a loja
        </Link>
        <Link
          className='flex items-center justify-center gap-2 rounded-lg border-2 border-gray-300 px-6 py-3 font-semibold text-gray-900 transition-all hover:border-gray-400 hover:bg-gray-50 active:scale-95'
          href='/lojas'
        >
          Ver lojas
        </Link>
      </div>

      <div className='rounded-lg border border-gray-200 bg-gray-50 p-4'>
        <p className='text-center font-medium text-gray-700 text-xs'>
          Dica: verifique o URL para encontrar a loja desejada.
        </p>
      </div>
    </main>
  )
}
